import usePendingConceptReplyStore from './stores/usePendingConceptReplyStore';

type ConceptReplyContext = {
  intent?: string;
  origin?: string;
};

/**
 * Called once at startup. If Outlook opened the taskpane via the InfoBar action,
 * `getInitializationContextAsync()` returns the JSON we set on the notification.
 * When it carries `intent: "generateConceptReply"` we mark the store as pending
 * so `useAutoGenerateConceptReply` can fire as soon as the email is loaded.
 */
export default async function initConceptReplyDeepLink(): Promise<void> {
  try {
    await Office.onReady();

    const item = Office.context.mailbox?.item as
      | (Office.Item & {
          getInitializationContextAsync?: (
            callback: (result: Office.AsyncResult<string>) => void,
          ) => void;
        })
      | undefined;

    if (!item?.getInitializationContextAsync) return;

    const raw = await new Promise<string | undefined>((resolve) => {
      item.getInitializationContextAsync!((result) => {
        if (result.status === Office.AsyncResultStatus.Succeeded) {
          resolve(result.value);
        } else {
          resolve(undefined);
        }
      });
    });

    if (!raw) return;

    const parsed = JSON.parse(raw) as ConceptReplyContext;
    if (parsed.intent !== 'generateConceptReply') return;

    usePendingConceptReplyStore
      .getState()
      .actions.request(parsed.origin ?? 'infobar');
  } catch {
    // Initialization context is optional — silently ignore if unavailable.
  }
}
